import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classes from "./EditCourse.module.css";
import SelectStudents from "../NewCourse/SelectStudents";
import TreeEditTopic from "./TreeEditTopic";
import EditCourseMenu from "./EditCourseMenu";
import { coursesApi, studyGroupsApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { ParticipantTypeEnumText } from "../../../../models/ParticipantTypeEnum";


const EditCourse = ({ isProfession }) => {
    const texts = useSelector(state => state.translate.texts);
    const isSupervisor = useSelector(state => state.auth.user.permissions?.EditCourse);
    let { id } = useParams();
    const [studyGroup, setStudyGroup] = useState()
    const dispatch = useDispatch()
    const componentMounted = useRef(true);

    const handleChangeStudyGroupDescription = (description) => {
        setStudyGroup((prevStudyGroup) => ({ ...prevStudyGroup, description: description }))
    }

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    useEffect(() => {
        if (isProfession && isSupervisor) {
            const data = {
                id: id,
            }
            coursesApi.coursesFilterRangePost({ coursesRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.coursesFilterError, error: error, statusCode: response?.statusCode, message: "coursesFilterRangePost " + error.message, level: 2, component: "EditCourse", line: 32 }))
                } else {
                    if (componentMounted.current) {
                        setStudyGroup(resdata.map(r => {
                            const parse = r.additionalData && JSON.parse(r.additionalData)
                            return { ...r, backgroundImage: parse?.backgroundImage, baseColor: parse?.baseColor }
                        }))
                    }
                }
            })

        } else {
            const data = {
                id,
                participantType: ParticipantTypeEnumText.teacher
            }
            studyGroupsApi.studyGroupsFilterRangePost({ studyGroupsRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.studyGroupsFilterError, error: error, statusCode: response?.statusCode, message: "studyGroupsFilterError " + error.message, level: 1, component: "EditCourse", line: 48 }))
                }
                else {
                    if (componentMounted.current) {
                        setStudyGroup(resdata.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)))
                    }
                }
            })
        }
    }, [isSupervisor, id])


    return (
        <div className={classes.EditCourse}>
            <EditCourseMenu currentIndex={0} studyGroup={studyGroup}>
                <div title={texts.studySubjects}>
                    <TreeEditTopic isProfession={isProfession} studyGroup={studyGroup} />
                </div>
                {!isProfession && <div title={texts.editStudents}>
                    <SelectStudents studyGroup={studyGroup} studyGroupId={id} handleChangeStudyGroupDescription={handleChangeStudyGroupDescription}></SelectStudents>
                </div>}
            </EditCourseMenu>
        </div>
    )
}

export default EditCourse;